// src/Components/About.js
import React from 'react';
import { FaTooth, FaUserMd, FaHospitalUser, FaHeartbeat, FaEye } from 'react-icons/fa';
import './About.css'; // We will create this CSS file next
import aboutfirst from "./assets/about-first.jpg";


const About = () => {
    return (
        <div className="about-page">
            {/* Hero Section */}
            <section className="page-hero-banner">
                <div className="container">
                    <h1>About Us</h1>
                    <p>Your Data Protection & Online Privacy Commitment</p>
                </div>
            </section>

            {/* Main About Content */}
            <section className="about-main section-padding">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="about-image">
                                <img src={aboutfirst} alt="Privacy Shield Data Protection" className="img-fluid rounded" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h2 className="section-title">Zero Data Collection: Our Privacy Guarantee</h2>
                            <p className="lead">A cookie-free, tracking-free website designed to protect your personal information and browsing privacy.</p>
                            <p>We operate without analytics scripts, tracking pixels, or third-party data collection. Your visit remains completely anonymous with no digital footprint or personal information stored.</p>

                            <h3 className="mt-4">No Data Collection Policy</h3>
                            <p>We are committed to protecting your online privacy. Our website does not collect, store, or share any personal information. You can browse freely without cookies, session tracking, or analytics monitoring. We comply with global privacy standards including <strong>GDPR, CCPA, and other data protection regulations</strong>.</p>

                            <h3 className="mt-4">Cookie-Free Browsing Experience</h3>
                            <p>Unlike most websites, we use zero tracking cookies, zero analytics scripts, and zero third-party services. Your browsing activity remains private and secure. No personal data is collected, no digital fingerprinting occurs, and no information is shared with external platforms.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission & Vision Section */}
            <section className="mission-vision section-padding bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <div className="card h-100 text-center p-4">
                                <div className="card-icon mb-3"><FaHeartbeat size={40} /></div>
                                <h3>GDPR & CCPA Compliance</h3>
                                <p>We fully comply with international data protection regulations. Your privacy rights are respected, protected, and never compromised on our platform.</p>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card h-100 text-center p-4">
                                <div className="card-icon mb-3"><FaEye size={40} /></div>
                                <h3>Transparency Commitment</h3>
                                <p>Complete transparency about our data practices. We have zero hidden trackers, no analytics, and absolutely no third-party data sharing.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats / Highlights Section */}
            <section className="stats-highlights section-padding">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-md-4 mb-4">
                            <h3><span className="counter">100</span>%</h3>
                            <p>No Tracking Cookies</p>
                            <small>Zero tracking cookies used on our website. Complete privacy protection.</small>
                        </div>
                        <div className="col-md-4 mb-4">
                            <h3>24/7</h3>
                            <p>Privacy Protection</p>
                            <small>Your data is protected around the clock with our privacy-first approach.</small>
                        </div>
                        <div className="col-md-4 mb-4">
                            <h3>100%</h3>
                            <p>Anonymous Browsing</p>
                            <small>Browse with complete anonymity. No personal information collected ever.</small>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;